import React from 'react'
import { FilterToolbar } from '@adc/ui-core'
import type { FilterToolbarProps } from '@adc/ui-core'

export type SmallFilterToolbarProps = Omit<FilterToolbarProps, 'size'>

/**
 * SmallFilterToolbar
 * A wrapper component around FilterToolbar with hardcoded 'small' size.
 * This provides a consistent small-sized filter toolbar across the Morpheus applications.
 */
const SmallFilterToolbar: React.FC<SmallFilterToolbarProps> = props => {
  return <FilterToolbar {...props} size='small' />
}

export default SmallFilterToolbar
